import { createContext, useContext } from 'react';
import type { ColorMode, ResolvedColorMode } from './colorMode';

export interface ColorModeContextValue {
    /** What the user chose — including 'system'. */
    mode: ColorMode;
    /** What that currently means, once the device's setting is applied. */
    resolvedMode: ResolvedColorMode;
    /** Switch the appearance and remember the choice. */
    setMode: (mode: ColorMode) => void;
}

/**
 * Lives apart from LocalizedThemeProvider so that file exports only its
 * component (a file mixing the two breaks Fast Refresh — see the react-refresh
 * lint rule). Same split as localeContext.
 */
export const ColorModeContext = createContext<ColorModeContextValue>({
    mode: 'system',
    resolvedMode: 'light',
    setMode: () => {}
});

/** The current appearance + a way to change it (see LocalizedThemeProvider). */
export function useColorMode(): ColorModeContextValue {
    return useContext(ColorModeContext);
}
